import { createReducer, updateState } from '../handlers'
import types from './types'

const initialState = {
  isActive: true,
  generalList: true,
  assignedList: true,
  inChat: true,
  textMsg: true,
  note: true,
  voiceNote: true,
  pdf: true,
  imageVideo: true,
  location: true,
  duration: 2000,
  withPreview: true,
  sound: 'default',
  inChatSound: 'default',
  channels: [],
  delivery: {
    email: true,
    inChatEmail: true,
    desktop: true,
    app: true
  },
  emailInterval: 600000,
  inChatEmailInterval: 600000,
  schedule: {}
}

const update = (state, action) => updateState(state, action.data)

export default createReducer(initialState, {
  [types.update]: update
})
